import { render, staticRenderFns } from "./billingRun.vue?vue&type=template&id=52d2862c&scoped=true"
import script from "./billingRun.vue?vue&type=script&lang=js"
export * from "./billingRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2862c",
  null
  
)

export default component.exports